const initialState = {
    "paso": 0,
    "servicios": 0,
    "medicos": {
        contratacion:'general',
        estado:'0',
        municipio:'0',
        especialidad:'0',
        circulo:'0',
        nombre: '',
        apaterno: '',
        amaterno: ''
    },
    "hospitales": {
        contratacion:'general',
        estado:'0',
        municipio:'0',
        plan:'0'
    },
    "listaMedicos": [],
    "listaHospitales": [],
    "estados": [],
    "municipios": [],
    "opcional": {},
    "especialidades": [],
    "circulos": [],
    "planes": [],
    "planeslp": [],
    "planeslc": [],
    "finalizo": false,
    "marcadoresFlag": false,
    "listaMarcadores": [],
    "errorServidor": false,
}

export function directorioRdc(state = initialState, action) {
    switch (action.type) {
        case "DIRECTORIO_OPCIONAL":
            return {...state,
                "opcional": action.opcional
            }
        case "DIRECTORIO_PASO":
            return {...state,
                "paso": action.paso
            }
        case "DIRECTORIO_PASO_ANTERIOR":
            return {...state,
                "paso": state.paso - 2
            }
        case "DIRECTORIO_PASO_SIGUIENTE":
            return {...state,
                "paso": state.paso + 1
            }
        case "DIRECTORIO_SERVICIOS_FORM":
            return {...state,
                "servicios": action.servicios
            }
        case "DIRECTORIO_RESET_FORM":
            return {...state,
                "medicos": initialState.medicos,
                "hospitales": initialState.hospitales
            }
        case "DIRECTORIO_MEDICOS_FORM":
            return {...state,
                "medicos": action.medicos
            }
        case "DIRECTORIO_HOSPITALES_FORM":
            return {...state,
                "hospitales": action.hospitales
            }
        case "DIRECTORIO_LLENAR_MEDICOS":
            return {...state,
                "listaMedicos": action.listaMedicos
            }
        case "DIRECTORIO_LLENAR_HOSPITALES":
            return {...state,
                "listaHospitales": action.listaHospitales
            }            
        case "DIRECTORIO_LLENAR_ESTADOS":
            return {...state,
                "estados": action.estados
            }
        case "DIRECTORIO_LLENAR_MUNICIPIOS":
            return {...state,
                "municipios": action.municipios
            }
        case "DIRECTORIO_LLENAR_ESPECIALIDADES":
            return {...state,
                "especialidades": action.especialidades
            }
        case "DIRECTORIO_LLENAR_CIRCULOS":
            return {...state,
                "circulos": action.circulos
            }
        case "DIRECTORIO_LLENAR_PLANES_SUBPLANES":
            return {...state,
                "planesSubplanes": action.planesSubplanes
            }
        case "DIRECTORIO_LLENAR_PLANES":
            var planlc = [];
            var planlp = [];
    		for (var plan of action.planes ) {
    		    //0-ambos 1-linea personal 2-linea comercial
    		    if(plan.lineaNegocio == 0)
    		    {
    		        planlc.push(plan);
    		        planlp.push(plan);
    		    }
    		    else if(plan.lineaNegocio == 1)
    		    {
    		        planlp.push(plan);
    		    }
    		    else if(plan.lineaNegocio == 2)
    		    {
    		        planlc.push(plan);
    		    }
    		}
            return {...state,
                "planes": action.planes,
                "planeslp": planlp,
                "planeslc": planlc
            }
        case "DIRECTORIO_FINALIZO":
            return {...state,
                "finalizo": action.finalizo
            }
        case "DIRECTORIO_MARCADORES_FLAG":
            return {...state,
                "marcadoresFlag": action.marcadoresFlag
            }
        case "DIRECTORIO_LLENAR_MARCADORES":
            return {...state,
                "listaMarcadores": action.listaMarcadores
            }
        case "ERROR_SERVIDOR":
            return {...state,
                "errorServidor": action.errorServidor
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/directorio/reducer.js